let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4w4Gh")).then(() => parcelRequire('95CMo'));